import { combineReducers } from 'redux';

// IMPORT REDUCERS
import { PostsBySearchQueryReducer, SelectedSearchReducer } from './SearchReducer';
import { NewAlbumsReducer } from './HomeReducer';
import { SongPlayerReducer, ShowPlayerReducer } from './PlayerReducer';
import { PlaylistReducer } from './PlaylistReducer';
import { AlbumReducer } from './AlbumReducer';
import { UserReducer } from './UserReducer';
import { ResultsReducer } from './ResultsReducer';
import { OrderReducer } from './OrdersReducer';
import { OrderHistoryReducer } from './OrderHistoryReducer';

import { ModalLoginReducer } from './ModalLoginReducer';
import { DataDefaultReducer } from './DataDefaultReducer';

import FilterReducer from './FilterReducer';

import { FavoritesReducer } from './FavoritesReducer';
import { FavoritesOtherReducer } from './FavoritesOtherReducer';
import { CategoriesReducer } from './CategoriesReducer';
import { ErrorsReducer } from './ErrorsReducer';

// EXPORT APP REDUCER
export const AppReducer = combineReducers({
  orders: OrderReducer,
  search: PostsBySearchQueryReducer,
  searchSelected: SelectedSearchReducer,
  newAlbums: NewAlbumsReducer,
  currentAlbum: AlbumReducer,
  playerSong: SongPlayerReducer,
  showPlayer: ShowPlayerReducer,
  playlist: PlaylistReducer,
  user: UserReducer,
  results: ResultsReducer,
  orderHistory: OrderHistoryReducer,
  modalLogin: ModalLoginReducer,
  categories: CategoriesReducer,
  genres: DataDefaultReducer('GENRE'),
  moods: DataDefaultReducer('MOOD'),
  energys: DataDefaultReducer('TEMPO'),
  vocals: DataDefaultReducer('VOCAL'),
  instruments: DataDefaultReducer('INSTRUMENT'),
  filters: FilterReducer,
  favorites: FavoritesReducer,
  favorites_other: FavoritesOtherReducer,
  errors: ErrorsReducer
});



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js